import * as Sentry from "@sentry/react";

/* Util method to capture errors for sentry
 * This method is async to not block the main thread, in addition
 * this proxy exists to help with imports and making mocking easier to test
 * @params { Error } e - error to be passed through to sentry
 */
export const captureException = async (e: Error) => Sentry.captureException(e);
